import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobComment.Delete.IRequest;
type Response = Api.Core.ClaimJobComment.Delete.IResponse;
type Headers = Api.Core.ClaimJobComment.Delete.IHeaders;
const url = '/api/Claims/ClaimJobComment/:id';
export default async function claimJobCommentDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
